import { COHORTS, useCohort } from "@/components/user-context";

import { useGetUpgradeWacExperiment } from "../../../utils/get-existing-sites";
import { LoggedInJiraNewUser } from "../components/logged-in-jira-new-user";

import { LoggedInJiraPremiumExistingUser } from "./existing-user";
import { LoggedInJiraPremiumUpgradeEligibleUser } from "./upgrade-eligible-user";

export const LoggedInJiraPremium = () => {
    const cohort = useCohort();
    const {
        isPartOfUpgradeWacExperimentAudience,
        cohort: experimentGroup,
        exposureFired,
        fireExposure
    } = useGetUpgradeWacExperiment();
    if (cohort === COHORTS.NEW_USER) {
        return <LoggedInJiraNewUser />;
    }

    if (isPartOfUpgradeWacExperimentAudience) {
        if (!exposureFired) {
            fireExposure();
        }

        if (experimentGroup === "variation") {
            // Exposure is also fired in the child component to this component
            return <LoggedInJiraPremiumUpgradeEligibleUser />;
        }
    }

    if (cohort === COHORTS.UPGRADE_ELIGIBLE_USER) {
        // Exposure is fired in the child component to this component
        return <LoggedInJiraPremiumUpgradeEligibleUser />;
    }

    if (cohort) {
        return <LoggedInJiraPremiumExistingUser />;
    }

    return null;
};
